const e = (a, r) => {
  switch (r.type) {
    case "ACTION_TYPE_SELECTED":
      return {
        ...a,
        actionType: r.payload.value,
        actionTypeError: void 0,
        params: r.payload.initialParams,
        paramsConfig: r.payload.initialParamsConfig
      };
    case "ACTION_TYPE_ERROR":
      return {
        ...a,
        actionTypeError: r.payload
      };
    case "SKIP_CONDITION_UPDATED":
      return {
        ...a,
        skipCondition: r.payload
      };
    case "CONTINUE_CONDITION_UPDATED":
      return {
        ...a,
        continueCondition: r.payload
      };
    case "CONTINUE_CONDITION_LANGUAGE_UPDATED":
      return {
        ...a,
        continueConditionLanguage: r.payload
      };
    case "SKIP_CONDITION_LANGUAGE_UPDATED":
      return {
        ...a,
        skipConditionLanguage: r.payload
      };
    case "PARAMS_UPDATED":
      return {
        ...a,
        params: r.payload
      };
    case "PARAMS_CONFIG_UPDATED":
      return {
        ...a,
        paramsConfig: r.payload
      };
    case "PARAMS_VALIDATION_ERROR":
      return {
        ...a,
        paramErrors: r.payload
      };
    case "DESCRIPTION_UPDATED":
      return {
        ...a,
        description: r.payload
      };
    default:
      return a;
  }
};
export {
  e as stepFormReducer
};
